import { PaddingType } from "store/features/memeGenerator/types/padding";
import { useAppSelector } from "store/store";

export const usePadding = (type: PaddingType) => {
    const padding = useAppSelector((state) => state.memeGenerator.meme?.padding.instances.find((p) => p.type === type));
    const color = useAppSelector((state) => state.memeGenerator.meme?.padding.color);
    if (!color) throw new Error("Padding color not found.");
    return {
        padding,
        color,
    };
};
